<template>
    <div id="chartModal">
        <el-dialog title="实时数据监测" :visible.sync="modalChart.show" @close="closeDialog()" width="35%" id="chartModalBox" @opened="opened()">
            <div id="bigChart" style="width:100%;height:400px">

            </div>
        </el-dialog>
    </div>
</template>

<script>
    import echarts from 'echarts'

    export default {
        name: 'ChartModal',
        props:{
            modalChart:Object,
            optionMini:Object,
            measure_no:'',
            content:'',
            early_warn_value:'',
            warn_value:'',
            unit:''
        },
        data () {
            return {

            }
        },
        // 用watch()函数来监听数据的更新，一旦数据更新了，那么就在watch()函数中调用drawLine()函数，用于更新视图
        watch:{
            optionMini(curVal,oldVal){
                // console.log(curVal);
                // console.log('curVal: ', curVal.series[0].data);
                this.drawLine(curVal);
            }
        },
        methods:{
            opened(){
                this.drawLine(this.optionMini);
            },
            drawLine(val){
                const date = val.xAxis[0].data
                const data = val.series[0].data
                for(let i = 0; i < val.series.length; i++){
                    val.series[i].type = 'line';
                }
                let option = {
                    xAxis: {
                        data: date,
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            formatter:`{value}${this.unit}`,
                        },
                    },
                    series: val.series,
                    title:{
                        // text:this.content + "-" + this.measure_no + "测点数据详细图"
                        text:`${this.content}-${this.measure_no}测点数据详细图`
                    },
                    tooltip: {
                        trigger: 'axis',
                    },
                }

                let bigChart = echarts.init(document.getElementById('bigChart'));

                bigChart.setOption(option,true);  // Echarts清除上次加载的数据
            },
            closeDialog(){
                this.modalChart.show = false;
            },
        }
    }
</script>

<style>

    #chartModal .el-dialog__header {
        padding: 20px 30px 10px;
        /*background-image: url('../../assets/img/modal_bg.png')*/
      background: linear-gradient(
        -90deg, rgb(60, 32, 242) 0%, rgb(52, 87, 222) 100%);
      border-radius: 2.5px 2.5px 0px 0px;
      transition: unset;
      text-align: center;
    }

    #chartModal .el-dialog__body {
        padding: 10px 20px;
    }

    #chartModal .el-dialog__title{
      text-align: center;
        font-size: 18px;
        color: #fff;
    }

</style>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/monitor/ChartModal.vue